import {ListViewProvider} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {EmployeeListHeader} from './components/header/EmployeeListHeader'
import {EmployeeTable} from './table/EmployeeTable'

import {useContext} from 'react'
import {KTCard} from '../../../../../_metronic/helpers/components/KTCard'
import {AlertContext} from '../../../../../_metronic/layout/components/alert-context'
import {AlertBox} from '../../../../../_metronic/layout/components/alert-message'

const EmployeeList = () => {
  return (
    <>
      <KTCard>
        <EmployeeListHeader />
        <EmployeeTable />
      </KTCard>
    </>
  )
}
const EmployeeMain = () => {
  const {show, message, type} = useContext(AlertContext)
  return (
    <div className='row'>
      {show && <AlertBox type={type === '1' ? 'success' : 'error'} message={message} />}
      <div className='col-lg-12'>
        <EmployeeList />
      </div>
    </div>
  )
}
const ListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <EmployeeMain />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {ListWrapper}
